/**
 * @generated SignedSource<<42bb0577a4d8fb5d5c0be223d981b9ef>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserSegmentationRedirectEntryQuery$variables = {
  accountId: string;
  cloudId: string;
};
export type UserSegmentationRedirectEntryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserSegmentationRedirect_fragment">;
};
export type UserSegmentationRedirectEntryQuery = {
  response: UserSegmentationRedirectEntryQuery$data;
  variables: UserSegmentationRedirectEntryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UserSegmentationRedirectEntryQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "UserSegmentationRedirect_fragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserSegmentationRedirectEntryQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
          },
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserSegRedirectAdvice",
        "kind": "LinkedField",
        "name": "jira_userSegRedirectAdvice",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "redirect"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
    "metadata": {},
    "name": "UserSegmentationRedirectEntryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "84997e1dc4b2632cf44e7fc7fd4fc910";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
